import { registerAwsDelegate } from "@p0security/integrations-aws-shared/delegates";
import { AwsIconUrl } from "@p0security/integrations-aws-shared/icon";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";
import { Delegate } from "@p0security/shared/types/access/index";

import { AwsOidcAccesses } from "./accesses.ts";
import { AwsOidcComponents } from "./components.ts";

const AwsOidcFilters = {} as const satisfies AnyFilterSchema;
export type AwsOidcFilters = typeof AwsOidcFilters;

export const AwsOidcRegistration = Registration({
  accesses: AwsOidcAccesses,
  category: "resource",
  components: AwsOidcComponents,
  docs: { install: "aws-oidc" },
  filters: AwsOidcFilters,
  itemKind: "identity provider",
  label: "AWS OIDC",
  logoUrl: AwsIconUrl,
  maturity: "preview",
  requestType: "bridge",
  useMapping: [
    { use: "iam_write", component: "identity" },
    { use: "identity", component: "identity" },
  ],
});

registerIntegration("aws-oidc", AwsOidcRegistration);

// Populates `aws`'s "policy" and "resource" delegates records with
// `aws-oidc`'s own accesses -- see `../aws/delegates.ts`'s doc comment for
// why `aws/accesses.ts` doesn't import `AwsOidcAccesses` directly.
registerAwsDelegate(
  "policy",
  "aws-oidc",
  Delegate({
    resource: "aws-oidc",
    accesses: AwsOidcAccesses,
    key: "identity",
  })
);
registerAwsDelegate(
  "resource",
  "aws-oidc",
  Delegate({
    resource: "aws-oidc",
    accesses: AwsOidcAccesses,
    key: "identity",
  })
);
